<!-- Localized -->
<template>
  <div>
    <FormulateForm #default="{ hasErrors }" class="min-h-full flex-1">
      <div class="flex flex-col justify-between min-h-full">
        <div class="form flex w-full flex-col flex-1">
          <FormulateInput
            class="w-full"
            :label="$t('pages.field_table.field_name')"
            :disabled="isFieldSystemProvided || queryData === 'view'"
            v-bind:style="{
              opacity: queryData !== 'view' ? 1 : 1,
              cursor: isFieldSystemProvided
                ? 'not-allowed'
                : queryData !== 'view'
                ? 'pointer'
                : 'not-allowed',
            }"
            :element-class="
              (context, classes) => {
                const additionalClasses =
                  queryData !== 'view' && !isFieldSystemProvided
                    ? 'opacity-100'
                    : 'opacity-50';
                return [`flex-1 min-w-full ${additionalClasses}`].concat(
                  classes
                );
              }
            "
            :placeholder="$t('pages.field_table.field_name')"
            type="text"
            validation="required"
            v-model="fieldData.name"
          />
          <FormulateInput
            class="w-full"
            :label="$t('pages.field_table.field_label')"
            :disabled="queryData === 'view'"
            :element-class="
              (context, classes) => {
                const additionalClasses =
                  queryData !== 'view' ? 'opacity-100' : 'opacity-50';
                return [`flex-1 min-w-full ${additionalClasses}`].concat(
                  classes
                );
              }
            "
            v-bind:style="{
              opacity: queryData !== 'view' ? 1 : 1,
              cursor: queryData !== 'view' ? 'pointer' : 'not-allowed',
            }"
            :placeholder="$t('pages.field_table.field_label')"
            type="text"
            validation="required"
            v-model="fieldData.label"
          />
          <FormulateInput
            v-model="entityTypesModel"
            @input="handleInput"
            class="w-full"
            :options="entityTypeOptions"
            variant="alt"
            :label="$t('pages.field_table.entity_type')"
            :disabled="
              queryData === 'view' ||
                isClonedSystemProvided ||
                isFieldSystemProvided
            "
            :placeholder="$t('pages.field_table.select_entity_type')"
            type="multi-select"
            validation="required"
            v-bind:style="{
              opacity: queryData !== 'view' ? 1 : 1,
              cursor:
                isFieldSystemProvided || isClonedSystemProvided
                  ? 'not-allowed'
                  : queryData !== 'view'
                  ? 'pointer'
                  : 'not-allowed',
            }"
            :element-class="
              (context, classes) => {
                const additionalClasses =
                  queryData !== 'view' && !isClonedSystemProvided
                    ? 'opacity-100'
                    : 'opacity-50';
                return [`flex-1 min-w-full ${additionalClasses}`].concat(
                  classes
                );
              }
            "
            :config="{
              ...ENTITY_TYPES_DROPDOWN_CONFIG,
              limit: 4,
            }"
          />
          <FormulateInput
            class="w-full testClass"
            :label="$t('pages.field_table.info_text')"
            :placeholder="$t('pages.field_table.info_text')"
            type="rich-text"
            validation="required"
            :element-class="
              (context, classes) => ['flex-1 min-w-full'].concat(classes)
            "
            v-model="fieldData.placeholder"
          />
          <FormulateInput
            class="w-full"
            :label="$t('pages.field_table.description')"
            :disabled="
              (fieldData && fieldData.is_restricted) || queryData == 'view'
            "
            :element-class="
              (context, classes) => ['flex-1 min-w-full'].concat(classes)
            "
            :placeholder="$t('pages.field_table.description')"
            type="textarea"
            v-model="fieldData.description"
          />
           <div class="flex gap-2 mt-4" v-if="useEmailPlaceholder">
                  <neo-toggle-switch  class="mt-1" :status="emailPlaceholder" @click="handleEmailPlaceholder()"/>
                  <span class="text-m text-gray-500">Use as Placeholder in Email Templates</span>
                </div>
        </div>

        <div class="card-actions justify-end" v-if="!fieldData.is_restricted">
          <Button
            :text="$t('pages.field_table.save')"
            type="primary"
            :disabled="hasErrors"
            @click.native="$emit('saveCreateField')"
          />
        </div>
      </div>
    </FormulateForm>
    <placeholderUsageModal
            :open="placeholderInEmail"
            :field="fieldData.name"
            @close="closeDeletePackageModal"
            :fieldName="fieldData.name"
            :emailTemplates="emailTemplates"
  />
  </div>
</template>

<style scoped></style>

<script>
const Button = () => import("@/components/button");
import { ENTITY_TYPES_DROPDOWN_CONFIG } from "@shared/utils/constants";
import NeoToggleSwitch from "@shared/components/toggle-switch";
const placeholderUsageModal = () => import("@/pages/field-table/field-admin-view/placeholderUsageModal.vue");

export default {
  name: "label-info-rich-text",
  props: [
    "fieldData",
    "queryData",
    "entityTypeOptions",
    "isClonedSystemProvided",
    "isFieldSystemProvided",
    "fieldOptions",
    "useEmailPlaceholder",
    "emailPlaceholder",
    "emailTemplates",
  ],
  components: {
    Button,
    NeoToggleSwitch,
    placeholderUsageModal,
  },
  data() {
    return {
      ENTITY_TYPES_DROPDOWN_CONFIG,
      placeholderInEmail: false,
    };
  },
  computed: {
    entityTypesModel: {
      get() {
        return this.fieldData.entity_types;
      },
      set(val) {
        if (this.fieldOptions.some((opt) => !!opt.dependents?.length)) {
          this.$toast.error(
            this.$t('pages.field_table.error_update_entity_type_associated_cascade')
          );
        } else {
          this.fieldData.entity_types = val;
        }
      },
    },
  },
  methods: {
    handleInput() {
      this.$emit("handleInput");
    },
    async handleEmailPlaceholder() {
            try {
                    if(this.emailTemplates.length > 0 && this.emailPlaceholder) {
                        this.placeholderInEmail =  true;
                        this.emailPlaceholder = true;
                    } else this.emailPlaceholder = !this.emailPlaceholder;
                    this.$emit('handlePlaceholder', this.emailPlaceholder)
            } catch(error) {
                console.log(error);
            }
    },
    closeDeletePackageModal() {
      this.placeholderInEmail = false;
    },
  },
};
</script>
